import React from 'react';
import { HowItWorksSection } from './how-it-works/how-it-works';
import { Box, Container } from '@material-ui/core';
import { ShortDescription } from './short-description/short-description';
import { FreeTrial } from './free-trial/free-trial';
import { DiscountOffer } from './discount-offer/discount-offer';
import { MeetTrainers } from './meet-trainers/meet-trainers';

const HIDE_TRAINERS = true

const Sections = () => {
  return (
    <>
      <Container maxWidth="lg">
        <Box mt={10} />
        <ShortDescription />
        <Box mt={10} />
        <HowItWorksSection />
        {!HIDE_TRAINERS &&(
          <>
            <Box mt={10} />
            <MeetTrainers />
          </>
        )
      }
        <Box mt={10} />
        <FreeTrial />
        <Box mt={14} />
        <DiscountOffer />
        <Box mt={10} />
      </Container>
      {/* TODO: enable for habit landing page */}
      {/* <HabitFormation.desktop /> */}
    </>
  );
};

export default Sections;
